module.exports = __webpack_public_path__ + "static/u-s-states-with-the-most-bankruptcies-2017-1-271e9cbf8a82c41913c295f927c38f09.png";